export enum CiType {
  'Test' = 'T',
  'Package' = 'P',
  'Subgroup' = 'SG',
}
